import { render, staticRenderFns } from "./pixel.vue?vue&type=template&id=a4c9e15c&scoped=true"
import script from "./pixel.vue?vue&type=script&lang=ts"
export * from "./pixel.vue?vue&type=script&lang=ts"
import style0 from "./pixel.vue?vue&type=style&index=0&id=a4c9e15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c9e15c",
  null
  
)

export default component.exports